import { create } from 'zustand'

type SendVerificationCodeState = {
  phoneNumber: string
  verificationId: string
  token?: string
  isPending: boolean
  setPhoneNumber: (value: string) => void
  setVerificationId: (value: string) => void
  setIsPending: (value: boolean) => void
  setToken: (value: string) => void
  reset: () => void
}

export const useSendVerificationCodeStore = create<SendVerificationCodeState>(
  set => ({
    phoneNumber: '',
    verificationId: '',
    isPending: false,
    setPhoneNumber: phoneNumber => set({ phoneNumber }),
    setVerificationId: verificationId => set({ verificationId }),
    setIsPending: isPending => set({ isPending }),
    setToken: token => set({ token }),
    reset: () =>
      set({
        phoneNumber: '',
        verificationId: '',
        isPending: false,
      }),
  }),
)
